module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-date-shortcut"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      staticClass: "el-date-shortcut__item",
      on: {
        "click": function($event) {
          _vm.handleItemClick(index)
        }
      }
    }, [_c('a', {
      class: {
        'el-date-shortcut__a': true, active: index === _vm.active
      },
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(item.text))])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2900ea8a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/DateShortCut/DateShortCut.vue
// module id = 749
// module chunks = 8